/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  UpdateDestinationRequestBody,
  UpdateDestinationRequestBody$Outbound,
  UpdateDestinationRequestBody$outboundSchema,
} from "../components/updatedestinationrequestbody.js";

export type UpdateDataExportDestinationSecurityOption1 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type UpdateDataExportDestinationSecurityOption2 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type UpdateDataExportDestinationSecurity = {
  option1?: UpdateDataExportDestinationSecurityOption1 | undefined;
  option2?: UpdateDataExportDestinationSecurityOption2 | undefined;
};

export type UpdateDataExportDestinationRequest = {
  /**
   * Destination ID.
   */
  id: string;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
  updateDestinationRequestBody: UpdateDestinationRequestBody;
};

/** @internal */
export type UpdateDataExportDestinationSecurityOption1$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const UpdateDataExportDestinationSecurityOption1$outboundSchema:
  z.ZodMiniType<
    UpdateDataExportDestinationSecurityOption1$Outbound,
    UpdateDataExportDestinationSecurityOption1
  > = z.pipe(
    z.object({
      projectSlugHeaderGramProject: z.string(),
      sessionHeaderGramSession: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
        sessionHeaderGramSession: "session_header_Gram-Session",
      });
    }),
  );

export function updateDataExportDestinationSecurityOption1ToJSON(
  updateDataExportDestinationSecurityOption1:
    UpdateDataExportDestinationSecurityOption1,
): string {
  return JSON.stringify(
    UpdateDataExportDestinationSecurityOption1$outboundSchema.parse(
      updateDataExportDestinationSecurityOption1,
    ),
  );
}

/** @internal */
export type UpdateDataExportDestinationSecurityOption2$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const UpdateDataExportDestinationSecurityOption2$outboundSchema:
  z.ZodMiniType<
    UpdateDataExportDestinationSecurityOption2$Outbound,
    UpdateDataExportDestinationSecurityOption2
  > = z.pipe(
    z.object({
      apikeyHeaderGramKey: z.string(),
      projectSlugHeaderGramProject: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        apikeyHeaderGramKey: "apikey_header_Gram-Key",
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      });
    }),
  );

export function updateDataExportDestinationSecurityOption2ToJSON(
  updateDataExportDestinationSecurityOption2:
    UpdateDataExportDestinationSecurityOption2,
): string {
  return JSON.stringify(
    UpdateDataExportDestinationSecurityOption2$outboundSchema.parse(
      updateDataExportDestinationSecurityOption2,
    ),
  );
}

/** @internal */
export type UpdateDataExportDestinationSecurity$Outbound = {
  Option1?: UpdateDataExportDestinationSecurityOption1$Outbound | undefined;
  Option2?: UpdateDataExportDestinationSecurityOption2$Outbound | undefined;
};

/** @internal */
export const UpdateDataExportDestinationSecurity$outboundSchema: z.ZodMiniType<
  UpdateDataExportDestinationSecurity$Outbound,
  UpdateDataExportDestinationSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => UpdateDataExportDestinationSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => UpdateDataExportDestinationSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function updateDataExportDestinationSecurityToJSON(
  updateDataExportDestinationSecurity: UpdateDataExportDestinationSecurity,
): string {
  return JSON.stringify(
    UpdateDataExportDestinationSecurity$outboundSchema.parse(
      updateDataExportDestinationSecurity,
    ),
  );
}

/** @internal */
export type UpdateDataExportDestinationRequest$Outbound = {
  id: string;
  "Gram-Session"?: string | undefined;
  "Gram-Key"?: string | undefined;
  "Gram-Project"?: string | undefined;
  UpdateDestinationRequestBody: UpdateDestinationRequestBody$Outbound;
};

/** @internal */
export const UpdateDataExportDestinationRequest$outboundSchema: z.ZodMiniType<
  UpdateDataExportDestinationRequest$Outbound,
  UpdateDataExportDestinationRequest
> = z.pipe(
  z.object({
    id: z.string(),
    gramSession: z.optional(z.string()),
    gramKey: z.optional(z.string()),
    gramProject: z.optional(z.string()),
    updateDestinationRequestBody: UpdateDestinationRequestBody$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramKey: "Gram-Key",
      gramProject: "Gram-Project",
      updateDestinationRequestBody: "UpdateDestinationRequestBody",
    });
  }),
);

export function updateDataExportDestinationRequestToJSON(
  updateDataExportDestinationRequest: UpdateDataExportDestinationRequest,
): string {
  return JSON.stringify(
    UpdateDataExportDestinationRequest$outboundSchema.parse(
      updateDataExportDestinationRequest,
    ),
  );
}
